import { ConnectionChecker } from 'blockly/core';
import type { Connection } from 'blockly/core';

import { isNumericVariableType } from './variableTypes.js';

function acceptsNumericVariableType(checks: string[] | null): boolean {
  return checks?.some((check) => isNumericVariableType(check)) ?? false;
}

function acceptsNumber(checks: string[] | null): boolean {
  return checks?.includes('Number') ?? false;
}

export class SkyroverConnectionChecker extends ConnectionChecker {
  override doTypeChecks(a: Connection, b: Connection): boolean {
    if (super.doTypeChecks(a, b)) {
      return true;
    }

    const checksA = a.getCheck();
    const checksB = b.getCheck();

    return (
      (acceptsNumber(checksA) && acceptsNumericVariableType(checksB)) ||
      (acceptsNumber(checksB) && acceptsNumericVariableType(checksA))
    );
  }
}
